import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4649b62c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=4649b62c&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=4649b62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649b62c",
  null
  
)

export default component.exports